// Lý do Gỡ xe / Hủy ghép — sync với BE enum CONTRACT_UNALLOCATE_REASON
// (backend/src/common/enum/contract.enum.ts). Value lowercase_snake.

export const CONTRACT_UNALLOCATE_REASON = {
  PRIORITY_OVER_7D: 'priority_over_7d',
  VEHICLE_DEFECT: 'vehicle_defect',
  CUSTOMER_CHANGE: 'customer_change',
  STOCK_REALLOCATION: 'stock_reallocation',
  OTHER: 'other',
};

export const CONTRACT_UNALLOCATE_REASON_LABEL = {
  [CONTRACT_UNALLOCATE_REASON.PRIORITY_OVER_7D]:
    'Ưu tiên KH khác (quá 7 ngày chưa xuất hóa đơn)',
  [CONTRACT_UNALLOCATE_REASON.VEHICLE_DEFECT]: 'Xe lỗi / vấn đề kỹ thuật',
  [CONTRACT_UNALLOCATE_REASON.CUSTOMER_CHANGE]: 'Khách đổi nhu cầu xe / màu',
  [CONTRACT_UNALLOCATE_REASON.STOCK_REALLOCATION]: 'Điều phối tồn kho',
  [CONTRACT_UNALLOCATE_REASON.OTHER]: 'Khác',
};

export const CONTRACT_UNALLOCATE_REASON_OPTIONS = Object.values(
  CONTRACT_UNALLOCATE_REASON,
).map((value) => ({ value, text: CONTRACT_UNALLOCATE_REASON_LABEL[value] }));
